import { cn } from "../../utils/classNames";

export default function FormField({
  label,
  hint,
  error,
  className = "",
  children,
}) {
  return (
    <label className={cn("block", className)}>
      {label && <span className="mb-2 block text-sm font-bold text-hookd-cream">{label}</span>}
      {hint && <span className="mb-2 block text-xs text-hookd-muted">{hint}</span>}
      {children}
      {error && <span className="mt-2 block text-xs font-semibold text-red-300">{error}</span>}
    </label>
  );
}

export const fieldClassName =
  "w-full rounded-hookd border border-hookd-line bg-hookd-ink/80 px-4 py-3 text-hookd-cream placeholder:text-hookd-muted focus:border-hookd-empress focus:outline-none focus:ring-2 focus:ring-hookd-empress/40";
